import { PageHead } from "@/components/UI/atoms/PageHead/PageHead";
import { RepairOrdersTable } from "@/components/UI/organisms/RepairOrdersTable/RepairOrdersTable";
import * as React from "react";
import styles from "./Archived.module.scss";
import { useRepairOrders } from "@/hooks/RepairOrders";
import _ from "lodash";
import { RosByMonth } from "@/components/UI/organisms/Charts/RosByMonth";
import { useWorkInProgress } from "@/hooks/WorkInProgress";
import { RosByService } from "@/components/UI/organisms/Charts/RosByService";
export interface IRequestsProps {}

export function Archived(props: IRequestsProps) {
	const { data: openRos, isLoading } = useRepairOrders("invoiced");
	const { data: wips } = useWorkInProgress();
	const repairOrders = React.useMemo(() => {
		return openRos.filter((ro) => wips.find((wip) => wip.roId === ro.wipId));
	}, [wips, openRos]);

	return (
		<div className={styles.requests}>
			<PageHead pageTitle="Archived" pageHead="Archived"></PageHead>
			<div className={styles.chartRow}>
				<div className={styles.chart}>
					<RosByService
						title="Invoiced Request by Type"
						loading={repairOrders.length === 0}
						repairOrders={repairOrders}></RosByService>
				</div>
				<div className={styles.chart}>
					<RosByMonth
						title="Invoiced Status by Month"
						loading={repairOrders.length === 0}
						repairOrders={repairOrders}></RosByMonth>
				</div>
			</div>
			<RepairOrdersTable
				repairOrders={repairOrders}
				emptyMessage="No archived repair orders"
				loading={isLoading && !repairOrders.length}></RepairOrdersTable>
		</div>
	);
}
